import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import { orderBy } from "lodash";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Package, Permission } from "types";
import { IsGranted } from "../../components/Common/IsGranted";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { PackageList } from "../../components/Product/Packages/PackageList";
import { ProductSearch } from "../../components/Product/ProductSearch";
import { useAutoFetchCollection } from "../../hooks/useAutoFetchCollection";
import { useSearch } from "../../hooks/useSearch";
import { Page } from "../Page";

export const PackageListPage = () => {
    const [search, setSearch] = useState("");
    const { data: packages, isLoading } = useAutoFetchCollection<Package>("packages");
    let filtered = useSearch(packages, (pkg) => [pkg.name, pkg.id], search);
    filtered = orderBy(filtered, (pkg) => pkg.name, ["asc"]);
    const isFiltered = search.length > 0;

    const history = useHistory();

    const handleCreate = () => {
        history.push(`/products/packages/new`);
    };

    return (
        <Page title="Packages">
            <ColumnLayout>
                <HeaderToolbar className="justify-between">
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Products</Breadcrumb.Item>
                        <Breadcrumb.Item>Packages</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ProductSearch onSearch={setSearch} />

                    <IsGranted permissions={Permission.PACKAGES_MODIFY}>
                        <Button color="primary" className="flex-shrink-0" icon={<PlusIcon />} onClick={handleCreate}>
                            Create Package
                        </Button>
                    </IsGranted>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <PackageList packages={filtered} isLoading={isLoading} isFiltered={isFiltered} />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
